__turbopack_context__.v({
  "backButton": "AuthForm-module-scss-module__tA0R8W__backButton",
  "form": "AuthForm-module-scss-module__tA0R8W__form",
  "otcInput": "AuthForm-module-scss-module__tA0R8W__otcInput",
  "otcWrapper": "AuthForm-module-scss-module__tA0R8W__otcWrapper",
  "recaptchaDisclaimer": "AuthForm-module-scss-module__tA0R8W__recaptchaDisclaimer",
  "resendEmailBlock": "AuthForm-module-scss-module__tA0R8W__resendEmailBlock",
  "resendEmailButton": "AuthForm-module-scss-module__tA0R8W__resendEmailButton",
  "resendEmailCountdown": "AuthForm-module-scss-module__tA0R8W__resendEmailCountdown",
  "resendEmailTimer": "AuthForm-module-scss-module__tA0R8W__resendEmailTimer",
  "socialBlock": "AuthForm-module-scss-module__tA0R8W__socialBlock",
  "socialBlockHidden": "AuthForm-module-scss-module__tA0R8W__socialBlockHidden",
  "socialBlockVisible": "AuthForm-module-scss-module__tA0R8W__socialBlockVisible",
  "socialButtonsLabel": "AuthForm-module-scss-module__tA0R8W__socialButtonsLabel",
  "socialButtonsWrapper": "AuthForm-module-scss-module__tA0R8W__socialButtonsWrapper",
  "subtitle": "AuthForm-module-scss-module__tA0R8W__subtitle",
  "subtitleButton": "AuthForm-module-scss-module__tA0R8W__subtitleButton",
  "title": "AuthForm-module-scss-module__tA0R8W__title",
  "wrapper": "AuthForm-module-scss-module__tA0R8W__wrapper",
});
